import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import Rsvp from './Rsvp';
import './rsvp.less';

const RsvpWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.RSVP_MANAGEMENT}`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.RSVP_MANAGEMENT}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Rsvp {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.RSVP_MANAGEMENT}/create`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.RSVP_MANAGEMENT}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Rsvp {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.RSVP_MANAGEMENT}/edit/:rsvpId`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.RSVP_MANAGEMENT}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Rsvp {...props} isEdit />
        </AccessControl>
      )}
    />
  </Switch>
);

export default RsvpWrapper;
